var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEqual = function SvgEqual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.653 13.316a.495.495 0 0 1-.4-.212.784.784 0 0 1-.167-.498c0-.203.055-.373.166-.507a.519.519 0 0 1 .418-.202h9.958c.156 0 .29.07.4.212.111.142.166.307.166.497a.772.772 0 0 1-.166.508.519.519 0 0 1-.417.202zm0-3.42a.495.495 0 0 1-.4-.212.784.784 0 0 1-.167-.497c0-.204.055-.374.166-.51a.516.516 0 0 1 .418-.205h9.958c.156 0 .29.072.4.215.111.143.166.31.166.5a.773.773 0 0 1-.166.508.519.519 0 0 1-.417.202z"
  })));
};
export default SvgEqual;